const api = (command) => new Promise((resolve, reject) => {
  if (window.__gpp) {
    window.__gpp(
      command,
      (result, success) => success ? resolve(result) : (
        /* istanbul ignore next */
        reject(new Error(`Unable to get ${command} data`))
      )
    );
  } else {
    reject(new Error("No __gpp found on window"));
  }
});
const getGPPData = () => api("ping");

export { getGPPData };
